import { List } from '@chakra-ui/react';
import { Children, isValidElement, type JSX, type ComponentProps } from 'react';

import type { ExtraProps } from 'react-markdown';

export function Ol({
  children,
}: ComponentProps<'ol'> & ExtraProps): JSX.Element {
  return (
    <List.Root as='ol' color='white'>
      {Children.toArray(children)
        .filter(isValidElement)
        .map((child: TAny, index) => {
          return <List.Item key={index}>{child.props.children}</List.Item>;
        })}
    </List.Root>
  );
}
